import { cloneElement, useState } from "react";
import {
  Placement,
  offset,
  flip,
  shift,
  autoUpdate,
  useFloating,
  useInteractions,
  useHover,
  useFocus,
  useRole,
  useDismiss,
} from "@floating-ui/react-dom-interactions";
import { cn } from "../../utils/cn";

interface TooltipProps {
  label: string;
  placement?: Placement;
  children: React.ReactElement<any>;
}

export const Tooltip = ({
  children,
  label,
  placement = "top",
}: TooltipProps) => {
  const [open, setOpen] = useState(false);

  const { x, y, reference, floating, strategy, context } = useFloating({
    placement,
    open,
    onOpenChange: setOpen,
    middleware: [offset(5), flip(), shift({ padding: 8 })],
    whileElementsMounted: autoUpdate,
  });

  const { getReferenceProps, getFloatingProps } = useInteractions([
    useHover(context),
    useFocus(context),
    useRole(context, { role: "tooltip" }),
    useDismiss(context),
  ]);
  const props = getFloatingProps({
    ref: floating,

    style: {
      position: strategy,
      top: y ?? "",
      left: x ?? "",
    },
  });
  return (
    <>
      {cloneElement(
        children,
        getReferenceProps({ ref: reference, ...(children.props || {}) }),
      )}
      {open && (
        <div
          className={cn(
            "cytooltip flex items-center justify-center rounded px-3 py-2 text-sm text-white",
            context.placement === "top"
              ? "cytooltip--bottom"
              : context.placement === "bottom"
                ? "cytooltip--top"
                : "",
          )}
          {...props}
        >
          <div>{label}</div>
        </div>
      )}
    </>
  );
};
